<app-header></app-header>
<main class="mt-115">
  <router-outlet></router-outlet>
  <div class="fab__container">
    <div class="fab__icon-holder fab-btn btn">
      <i class="fas fa-user-friends"></i>
      <span class="d-none d-md-inline"> Servicios</span>
    </div>
    <ul class="fab__options">
      <li routerLink="/consultadeudas">
        <span class="fab__label d-inline">Consulta y Pago de Deudas</span>
        <div class="fab__icon-holder">
          <i class="fas fa-file-invoice-dollar"></i>
        </div>
      </li>
      <li routerLink="/denunciaciudad">
        <span class="fab__label d-inline">Realizar Denuncia</span>
        <div class="fab__icon-holder">
          <i class="fas fa-comments"></i>
        </div>
      </li>
      <li routerLink="/reclamo">
        <span class="fab__label d-inline">Realizar Reclamo</span>
        <div class="fab__icon-holder">
          <i class="far fa-id-badge"></i>
        </div>
      </li>
    </ul>
  </div>
</main>
<app-footer></app-footer>
